<template>
    <div class="w-36 lg:w-52">
        <Listbox v-model="selectedVersion">
            <div class="relative mt-2 pl-6">
                <ListboxButton
                    class="relative w-full cursor-default rounded-lg bg-gray-800 py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm"
                >
                    <span class="block truncate">{{ selectedVersion?.name }}</span>
                    <span
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
                    >
                        <SelectorIcon
                            aria-hidden="true"
                            class="h-5 w-5 text-gray-400"
                        />
                    </span>
                </ListboxButton>

                <transition
                    leave-active-class="transition duration-100 ease-in"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0"
                >
                    <ListboxOptions
                        class="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-gray-800 py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                    >
                        <ListboxOption
                            v-for="version in versions"
                            :key="version.name"
                            v-slot="{ active, selected }"
                            :value="version"
                            as="template"
                        >
                            <li
                                :class="[
                                    active ? 'bg-amber-100 text-purple-400' : 'text-gray-50',
                                    'relative cursor-default select-none py-2 pl-10 pr-4',
                                ]"
                                @click="changeVersion(version.name)"
                            >
                                <span
                                    :class="[
                                        selected ? 'font-medium' : 'font-normal',
                                        'block truncate',
                                    ]"
                                >
                                    {{ version.name }}
                                </span>
                                <span
                                    v-if="selected"
                                    class="absolute inset-y-0 left-0 flex items-center pl-3 text-purple-400"
                                >
                                    <CheckIcon
                                        aria-hidden="true"
                                        class="h-5 w-5"
                                    />
                                </span>
                            </li>
                        </ListboxOption>
                    </ListboxOptions>
                </transition>
            </div>
        </Listbox>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/vue";
import { CheckIcon, SelectorIcon } from "@heroicons/vue/solid";
import { useRoute, useRouter } from "vue-router";

const versions = [
    { name: 6 },
    { name: 2022 },
    { name: 2021 },
    { name: 2020 }
];

const router = useRouter();
const route = useRoute();
const versionRegex = /\/([0-9]+?)($|\/)/;

const selectedVersion = computed(() =>
{
    const versionMatch = versionRegex.exec(route.path);
    if (versionMatch && versionMatch.length > 1)
    {
        const version = parseInt(versionMatch[1]);
        return versions.find(v => v.name == version);
    }
    else
    {
        return versions[0];
    }
});

function changeVersion (version: number)
{
    router.push(route.path.replace(versionRegex, "/" + version + "/"));
}

</script>
